<template>
  <div>
    <b-table
      bordered
      responsive
      sticky-column
      :items="models"
      :fields="fields"
    >
      <template v-slot:cell(name)="data">
        <img
          :src="avatar(data)"
          class="thumbnail mr-1"
        >
        {{ name(data) }}
      </template>

      <template v-slot:cell(now)="data">
        {{ data.item.now.value }}
      </template>
    </b-table>
  </div>
</template>

<script>

export default {
  data () {
    return {
      modelName: 'members',
      fields: [
        {
          key: 'name',
          label: '名前',
          thClass: 'members-th',
          tdClass: 'align-middle'
        },

        {
          key: 'now',
          label: 'ステータス',
          thClass: 'members-th',
          tdClass: 'align-middle'
        },

        {
          key: 'memo',
          label: 'メモ',
          thClass: 'members-th',
          tdClass: 'align-middle memo'
        }
      ]
    }
  },

  computed: {
    models () {
      return this.$store.getters[`${this.modelName}/getAttr`]('models')
    }
  },

  methods: {
    name (data) {
      const { first_name, last_name } = data.item.user
      return `${last_name} ${first_name}`
    },

    avatar (data) {
      const avatar = data.item.user.avatar
      const thumbnails = avatar.data.thumbnails
      if (thumbnails) {
        return thumbnails[6].url
      }
    }
  }
}
</script>

<style lang="scss">
.members-th {
  min-width: 180px;
  background: #34495e;
  color: white;
}

.thumbnail {
  width: 40px;
  height: 40px;
}

.memo {
  white-space: pre-wrap;
}
</style>
